<template>
    <v-dialog-old ref="dialog" id="questionModeration">
        <ConsultCancelDialog ref="consultCancelDialog" @canceled="onCancel"/>
        <RejectWithRefundDialog ref="rejectWithRefundDialog" @rejected="onRejectWithRefund"/>

        <form>
            <fieldset style="margin-bottom: 20px;">
                <legend class="comma">
                    <a :href="'https://doctu.ru/consult/question/' + question.title_slug"
                       target="_blank"
                       v-tooltip="'https://doctu.ru/consult/question/' + question.title_slug"
                    >
                        <span v-if="question.user_name">{{ question.user_name }}</span>
                        <span v-if="question.user_email">{{ question.user_email }}</span>
                    </a>
                </legend>

                <table class="grid">
                    <tr>
                        <td>
                        <span class="comma">
                            <span v-if="question.user_sex === 'MALE'">Мужчина</span>
                            <span v-if="question.user_sex === 'FEMALE'">Женщина</span>
                            <span v-if="question.user_age">{{ question.user_age | pluralize('', '$ год', '$ года', '$ лет') }}</span>
                            <span v-if="question.is_anonym">анонимно</span>
                        </span>
                        </td>
                        <td align="center" style="font-size: 16px;">
                            <b v-if="question.type === 'INDIVIDUAL'">Индивидуальный</b>
                        </td>
                        <td align="right">
                            <b v-if="question.type === 'FREE'">бесплатно</b>
                            <b v-else>{{ question.price }} руб.</b>
                        </td>
                    </tr>
                    <tr>
                        <td width="33%">
                            <select v-model="question.doctor_speciality_id" style="max-width: 500px;">
                                <option v-for="speciality in specialities" :value="speciality.value">
                                    {{ speciality.text }}
                                </option>
                            </select>
                        </td>
                        <td align="center" style="font-size: 16px;">
                            <b  v-if="question.type === 'INDIVIDUAL'">{{question.individualConsultant.fullName}}</b>
                        </td>
                        <td align="right">
                            <b>{{ question.created_at | formatDate }}</b>,
                            источник:
                            <span v-if="question.source === 'SITE'" tooltip="Сайт"><i class="fa fa-desktop"></i></span>
                            <span v-if="question.source === 'MOBILE'" tooltip="Mobile"><i class="far fa-mobile"></i></span>
                            <span v-if="question.source === 'ANDROID'" tooltip="Android"><i class="fab fa-android"></i></span>
                            <span v-if="question.source === 'IOS'" tooltip="iOs"><i class="fab fa-apple"></i></span>
                            <b>{{ question.source }}</b>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="3">
                            <div class="inputLargeMarkable">
                                <div v-text="question.title"></div>
                                <input v-model="question.title"
                                       class="large question-title"
                                       v-beautify.literal="'capitalize itemclean striptags trim typograf'">
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="4">
                            <div class="textareaMarkable">
                                <div v-text="question.text"></div>
                                <textarea v-model="question.text"
                                          class="question-text"
                                          v-beautify.literal="'capitalize itemclean striptags trim typograf'"/>
                            </div>
                            <div class="comma">
                                <a :href="prepareFileUrl(filename)" v-for="filename in question.files" target="_blank">
                                    <i class="fa fa-user" v-if="filename.includes('/photo/')"></i>
                                    <i class="fa fa-file" v-else></i>&nbsp;{{filename.replace(/^.*[\\\/]/, '')}}
                                </a>
                            </div>
                        </td>
                    </tr>

                    <tr>
                        <td colspan="2">
                            <strong v-if="question.moderated && !question.published">
                                {{ question.unpublish_reason }}
                            </strong>
                        </td>
                    </tr>

                </table>
            </fieldset>

            <footer>
                <template v-if="
                    (question.type !== 'FREE' && $can('admin.consult.questionsTable.questionsPayable.update')) ||
                    (question.type === 'FREE' && $can('admin.consult.questionsTable.questionsFree.update'))">
                    <template v-if="!question.moderated">
                        <v-loading-component @click="publish">
                            <template slot-scope="{ loadingClass }">
                                <button :class="['green', loadingClass]">Опубликовать</button>
                            </template>
                        </v-loading-component>
                        <button class="red" @click.prevent.stop="unpublish">Отклонить</button>
                    </template>
                    <template v-if="question.moderated && question.published">
                        <v-loading-component @click="save">
                            <template slot-scope="{ loadingClass }">
                                <button :class="['blue', loadingClass]">Сохранить</button>
                            </template>
                        </v-loading-component>
                        <button class="red" @click.prevent.stop="unpublish">Отклонить</button>
                    </template>
                    <template v-if="question.moderated && !question.published">
                        <v-loading-component @click="save">
                            <template slot-scope="{ loadingClass }">
                                <button :class="['blue', loadingClass]">Сохранить</button>
                            </template>
                        </v-loading-component>
                        <v-loading-component @click="publish" v-if="question.type === 'FREE'">
                            <template slot-scope="{ loadingClass }">
                                <button :class="['green', loadingClass]">Опубликовать</button>
                            </template>
                        </v-loading-component>
                    </template>
                </template>
                <template v-if="question.type === 'FREE' && $can('admin.consult.questionsTable.questionsFree.delete')">
                    <v-loading-component @click="deleteQuestion">
                        <template slot-scope="{ loadingClass }">
                            <button :class="['redHover', loadingClass]">Удалить</button>
                        </template>
                    </v-loading-component>
                </template>
                <template v-if="
                    ((question.type !== 'FREE' && $can('admin.consult.questionsTable.questionsPayable.update')) ||
                    (question.type === 'FREE' && $can('admin.consult.questionsTable.questionsFree.update')))
                ">
                    <v-loading-component @click="hideQuestion">
                        <template slot-scope="{ loadingClass }">
                            <button :disabled="question.hidden_at || !(question.closed_at || (!question.published && question.moderated_at))"
                                    :class="['blueHover', 'pull-right', loadingClass]">Скрыть</button>
                        </template>
                    </v-loading-component>
                    <button v-if="question.type !== 'FREE' && question.closed_at && question.published && !question.hasRefund"
                            @click.prevent.stop="rejectQuestionWithRefund"
                            class="red pull-right"
                            style="margin-right: 5px;">Отклонить с возвратом</button>
                </template>
            </footer>
        </form>
    </v-dialog-old>
</template>

<script>
import ConsultCancelDialog from "@dialogs/admin/consult/ConsultCancel";
import RejectWithRefundDialog from "@dialogs/admin/consult/RejectWithRefund";

export default {
    components: {
        ConsultCancelDialog,
        RejectWithRefundDialog
    },
    props: {
        specialities: {
            type: Array,
            required: true,
        }
    },
    data: function () {
        return {
            question: {
                id: '',
                doctor_speciality_id: '',
                moderated_at: '',
                published: '',
                text: '',
                title: '',
                title_slug: '',
                user_age: '',
                user_email: '',
                user_id: '',
                user_name: '',
                user_sex: '',
                votes_down: '',
                votes_up: '',
                type: 'FREE',
                price: null,
                is_anonym: 0,
            },
        };
    },
    methods: {
        resetData() {
            this.question = {
                id: '',
                doctor_speciality_id: '',
                moderated_at: '',
                published: '',
                text: '',
                title: '',
                title_slug: '',
                user_age: '',
                user_email: '',
                user_id: '',
                user_name: '',
                user_sex: '',
                votes_down: '',
                votes_up: '',
                type: 'FREE',
                price: null,
                is_anonym: 0,
            };
        },

        show(id) {
            this.resetData();
            let scope = this;

            return this.axios.post('questionsTable/read/' + id).then(response => {
                Object.assign(scope.question, response.data);
                scope.$refs.dialog.show();

                setTimeout(() => {
                    document.querySelectorAll('#questionModeration textarea, input')
                        .forEach(el => {
                            el.dispatchEvent(new Event('text:beautify'));
                            el.dispatchEvent(new Event('blur', { bubbles: true }));
                            if (el.classList.contains('question-text')) {
                                el.style.height = '53px';
                                el.style.height = 5 + el.scrollHeight + 'px';
                            }
                        });
                }, 1);
            });
        },

        makeRequest(requestType, data, btn = null) {
            btn?.startLoadingAnimation();

            this.axios.post('questionsTable/' + requestType + '/' + data.id, data)
                .then((response) => {
                    this.$emit('updated');
                    btn?.stopLoadingAnimation();
                    this.$refs.dialog.hide();
                })
                .catch(() => btn?.stopLoadingAnimation());
        },

        onCancel(unpublishReason) {
            let data = this.question;
            data.unpublish_reason = unpublishReason;

            this.makeRequest('reject', data)
        },

        save(btn) {
            this.makeRequest('update', this.question, btn);
        },

        publish(btn) {
            this.makeRequest('publish', this.question, btn);
        },

        unpublish() {
            this.$refs.consultCancelDialog.show();
        },

        hideQuestion (btn) {
            this.makeRequest('hide', this.question, btn);
        },

        rejectQuestionWithRefund() {
            this.$refs.rejectWithRefundDialog.show();
        },

        onRejectWithRefund(rejectQuestionReason, rejectDoctorAwardsReason) {
            this.makeRequest('rejectWithRefund', {
                id: this.question.id,
                rejectQuestionReason: rejectQuestionReason,
                rejectDoctorAwardsReason: rejectDoctorAwardsReason,
            })
        },

        deleteQuestion (btn) {
            this.$modal('Удалить?', {
                    name: 'Да',
                    btnClass: 'red',
                    callback: () => {
                        this.makeRequest('delete', this.question, btn);
                    }
                },
                {
                    name: 'Отмена'
                }
            );
        },

        prepareFileUrl(fileUrl) {
            return fileUrl.indexOf('http') === -1 ? '//' + fileUrl : fileUrl;
        },
    }
}
</script>

<style>
#questionModeration {
    width: 1000px;

    .textareaMarkable {
        position: relative;
        overflow: hidden;
    }
    .textareaMarkable textarea {
        font-size: 16px;
        padding: 3px;
        position: relative;
    }
    .textareaMarkable div {
        font-size: 16px;
        padding: 4px;
        position: absolute;
        top: 0;
        color: transparent;
        height: auto;
        width: 100%;
        pointer-events: none;
        white-space: pre-wrap;
        word-wrap: break-word;
    }
    .textareaMarkable div mark {
        color: transparent;
    }
    .inputLargeMarkable {
        position: relative;
        overflow: hidden;
    }
    .inputLargeMarkable input {
        font-size: 24px;
        font-weight: 700;
        position: relative;
    }
    .inputLargeMarkable div {
        font-size: 24px;
        font-weight: 700;
        padding: 0;
        position: absolute;
        top: 0;
        color: transparent;
        height: 0;
        pointer-events: none;
    }
    .inputLargeMarkable div mark {
        color: transparent;
    }
}
</style>
